import type {CopilotGenerateCommitMessageAuthInfo, EditInfo, WebCommitInfo} from '@github-ui/code-view-types'
import type {CopilotInfo} from '@github-ui/copilot-common-types'
import {useCurrentRepository} from '@github-ui/current-repository'
import {dynamic} from '@github-ui/dynamic'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'

import {useTreePaneContext} from '../contexts/TreePaneContext'
import {LoadingFallback} from './SuspenseFallback'

const BlobEditor = dynamic(() => import('../components/blob-edit/BlobEditor'), {
  ssr: false,
  loading: LoadingFallback,
})

export function CodeViewEditor({
  editInfo,
  path,
  webCommitInfo,
  copilotInfo,
  copilotGenerateCommitMessageAuthInfo,
}: {
  editInfo: EditInfo
  path: string
  webCommitInfo: WebCommitInfo
  copilotInfo?: CopilotInfo
  copilotGenerateCommitMessageAuthInfo?: CopilotGenerateCommitMessageAuthInfo
}) {
  const repo = useCurrentRepository()
  const {isTreeExpanded, collapseTree, treeToggleElement} = useTreePaneContext()

  return (
    <ErrorBoundary boundaryName="code-view-editor">
      <BlobEditor
        collapseTree={collapseTree}
        editInfo={editInfo}
        repo={repo}
        showTree={isTreeExpanded}
        treeToggleElement={treeToggleElement}
        // we need a key so that edit -> new soft nav does a fresh initial render
        key={`${path}_${editInfo.fileName}_${editInfo.isNewFile}`}
        webCommitInfo={webCommitInfo}
        copilotInfo={copilotInfo}
        copilotGenerateCommitMessageAuthInfo={copilotGenerateCommitMessageAuthInfo}
        isDataRouter
      />
    </ErrorBoundary>
  )
}
